import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Capabilities from "@/components/landing/Capabilities";
import Work from "@/components/landing/Work";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Home() {
  return (
    <div className="relative overflow-x-hidden">
      <div className="grain-overlay" />
      <Nav />
      <Hero />
      <Manifesto />
      <Capabilities />
      <EditorialMarquee />
      <Work />
      <Contact />
      <Footer />
    </div>
  );
}
